export default __webpack_public_path__ + "static/media/logo_metalheads.8ac28c94.svg";